export default __webpack_public_path__ + "static/media/categorie_icons_Confirmation.3ab60b79.svg";